import React from 'react';

import { Account } from '../data';

export interface AppAccountContext {
  account: Account;
}

export const AccountContext = React.createContext<AppAccountContext>({} as AppAccountContext);

export const AccountProvider: React.FC<React.PropsWithChildren<AppAccountContext>> = ({ children, ...value }) => (
  <AccountContext.Provider value={value}>{children}</AccountContext.Provider>
);

export const useAccount = () => {
  const context = React.useContext(AccountContext);
  if (!context) {
    throw new Error('useAccount must be used under AccountProvider');
  }
  return context;
};

export default AccountProvider;
